const WHATSAPP_NUMBER = "917567910215";
export default WHATSAPP_NUMBER;